// src/services/authService.js

import axios from "axios";
import { API_URL } from "../utils/apiUtils";

// Base URL for your API

export const login = async (loginValue, password) => {
  try {
    const response = await axios.post(`${API_URL}/auth/staff-login`, {
      loginValue,
      password,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Login failed. Please try again.";
  }
};
export const createUserService = async (values) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.post(`${API_URL}/auth/create-user`, values, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    throw (
      error.response?.data?.message || "Create user failed, Please try again."
    );
  }
};
export const updatePermissionsService = async (values) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.put(
      `${API_URL}/auth/update-permission`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw (
      error.response?.data?.message || "Create user failed, Please try again."
    );
  }
};
export const fetchUserService = async (values) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/auth/get-users`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    throw (
      error.response?.data?.message ||
      " Failed to fetch users, Please try again."
    );
  }
};
